/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! Behavioral Cohorts Engine — viewer.
 *  /cohorts -> cohort breakdown with retention ; /get?id=<vid> -> classify one visitor.
 *  Talks through the app's GS.api ({ok,status,data}). Deep-linkable via ?id=<vid>.
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  function segScope(sg){var h=document.querySelector('[data-segtitle]');if(!h||!sg||!sg.name)return;var s=h.querySelector('.gs-seg-scope');if(!s){s=document.createElement('span');s.className='gs-seg-scope';s.style.cssText='color:#6B7280;font-weight:500;font-size:.6em;margin-left:7px;letter-spacing:normal;vertical-align:middle';h.appendChild(s);}s.textContent='\u00b7 '+sg.name;}
  try { (window.GS_BUILD = window.GS_BUILD || {})["behavioral-cohorts"] = "1.0.1"; } catch (e) {}
  if (window.__bcohWired) return; window.__bcohWired = 1;

  var root = document.querySelector('[data-bc="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-bc="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function retCls(v) { return v >= 40 ? "hi" : (v >= 15 ? "mid" : "lo"); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function iso(ms) { return new Date(ms).toISOString().slice(0, 10); }
  var RANGE = { from: iso(Date.now() - 30 * 86400000), to: iso(Date.now()) };
  function _rpT(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;}
  function _rpYmd(d){return d.getUTCFullYear()+"-"+("0"+(d.getUTCMonth()+1)).slice(-2)+"-"+("0"+d.getUTCDate()).slice(-2);}
  function _rpToday(){var n=new Date();return new Date(Date.UTC(n.getUTCFullYear(),n.getUTCMonth(),n.getUTCDate()));}
  function _rpPreset(days){var to=_rpToday(),from=new Date(to.getTime()-(days-1)*86400000);var lbl={7:_rpT("an.last7"),30:_rpT("an.last30"),90:_rpT("an.last90"),365:_rpT("an.last12mo")}[days]||(days+" days");return {from:_rpYmd(from),to:_rpYmd(to),label:lbl,preset:String(days)};}
  (function _rpRestore(){try{var s=JSON.parse(localStorage.getItem("gs_bc_range")||"null");if(s&&s.preset){var p=_rpPreset(+s.preset);RANGE.from=p.from;RANGE.to=p.to;RANGE.label=p.label;RANGE.preset=p.preset;}else if(s&&s.from&&s.to){RANGE.from=s.from;RANGE.to=s.to;RANGE.label=s.from+" \u2192 "+s.to;RANGE.preset=null;}}catch(e){}if(!RANGE.label){var d=_rpPreset(30);RANGE.label=d.label;RANGE.preset="30";}})();
  function _rpInit(){
    function _rpBtnLabel(menu,preset){if(!menu||!preset)return null;var b=menu.querySelector('.rm[data-preset="'+preset+'"]');return b?b.textContent.trim():null;}
    
    if(RANGE&&RANGE.preset){var _rp=_rpPreset(+RANGE.preset);RANGE.label=_rp.label;}
    var btn=q("rangeBtn"),menu=q("rangeMenu"),lab=q("range-label");if(!btn||!menu)return;
    (function(){var _pp=(typeof RANGE!=="undefined"&&RANGE&&RANGE.preset)||(typeof _RPL!=="undefined"&&_RPL&&_RPL.preset);var _bl=_rpBtnLabel(menu,_pp);if(_bl){if(lab)lab.textContent=_bl;if(typeof RANGE!=="undefined"&&RANGE)RANGE.label=_bl;if(typeof _RPL!=="undefined"&&_RPL)_RPL.label=_bl;}})();
    if(lab&&RANGE.label)lab.textContent=RANGE.label;
    function sync(){menu.querySelectorAll(".rm[data-preset]").forEach(function(x){x.classList.toggle("on",x.getAttribute("data-preset")===RANGE.preset);});}
    btn.addEventListener("click",function(e){if(menu.contains(e.target)&&e.target!==btn)return;e.stopPropagation();var open=menu.style.display!=="none";menu.style.display=open?"none":"block";if(!open){var cf=menu.querySelector('[data-rp="from"]'),ct=menu.querySelector('[data-rp="to"]');if(cf)cf.value=RANGE.from;if(ct)ct.value=RANGE.to;sync();}});
    document.addEventListener("click",function(e){if(!btn.contains(e.target))menu.style.display="none";});
    function apply(o){ if(o&&o.preset){var _bl2=_rpBtnLabel(menu,o.preset);if(_bl2)o.label=_bl2;}RANGE.from=o.from;RANGE.to=o.to;RANGE.label=o.label;RANGE.preset=o.preset;if(lab)lab.textContent=RANGE.label;try{localStorage.setItem("gs_bc_range",JSON.stringify(RANGE));}catch(e){}menu.style.display="none";loadCohorts();}
    menu.querySelectorAll(".rm[data-preset]").forEach(function(b){b.addEventListener("click",function(){apply(_rpPreset(+b.getAttribute("data-preset")));});});
    var ap=menu.querySelector('[data-rp="apply"]');if(ap)ap.addEventListener("click",function(){var ff=menu.querySelector('[data-rp="from"]').value,tt=menu.querySelector('[data-rp="to"]').value;if(!ff||!tt)return;if(ff>tt){var x=ff;ff=tt;tt=x;}apply({from:ff,to:tt,label:ff+" \u2192 "+tt,preset:null});});
  }

  /* ---- cohort breakdown ---- */
  function loadCohorts() {
    GS.api("/plugin/behavioral-cohorts/cohorts?" + siteParam() + "&from=" + RANGE.from + "&to=" + RANGE.to).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      segScope(d.scoped_segment);
      var cs = d.cohorts || [];
      q("k_vis").textContent = num(d.total_visitors);
      q("k_coh").textContent = num(cs.length);
      var best = cs.slice().sort(function (a, b) { return (b.retention_7d || 0) - (a.retention_7d || 0); })[0];
      q("k_best").textContent = best ? best.archetype + " (" + best.retention_7d + "%)" : "—";
      var body = q("rows");
      if (!cs.length) { body.innerHTML = '<tr><td colspan="6" class="bc-empty">' + esc(d.note || TR('behavi.f2.no_behavioural_cohorts_in_this_ran')) + "</td></tr>"; return; }
      if (window.GSMore) GSMore.mount({ container: body, table: true, colspan: 6, items: cs, pageSize: 20, emptyText: TR('behavi.f2.no_behavioural_cohorts_in_this_ran'), render: row });
      else body.innerHTML = cs.map(row).join("");
    });
  }
  function row(c) {
    var a = c.avg || {};
    return "<tr>" +
      '<td><span class="bc-arch">' + esc(c.archetype) + '</span><div class="bc-share">' + (c.share || 0) + "% &middot; " + (c.avg_sessions || 0) + " sess/visitor</div></td>" +
      '<td class="r">' + num(c.visitors) + "</td>" +
      '<td class="r">' + (c.repeat_rate || 0) + "%</td>" +
      '<td class="r"><span class="bc-ret ' + retCls(c.retention_1d) + '">' + (c.retention_1d || 0) + "%</span></td>" +
      '<td class="r"><span class="bc-ret ' + retCls(c.retention_7d) + '">' + (c.retention_7d || 0) + "%</span></td>" +
      '<td class="r">' + (a.intent || 0) + "</td>" +
      "</tr>";
  }

  /* ---- classify one visitor ---- */
  function loadVisitor(vid) {
    if (!vid) return;
    var host = q("visitor");
    host.innerHTML = '<div class="bc-empty">Loading&hellip;</div>';
    GS.api("/plugin/behavioral-cohorts/get?" + siteParam() + "&id=" + encodeURIComponent(vid)).then(function (r) {
      var d = (r && r.ok && r.data) || {};
      if (!d.cohort) { host.innerHTML = '<div class="bc-empty">' + esc(d.note || TR('behavi.f2.no_cohort_for_this_visitor_yet')) + "</div>"; return; }
      var a = d.avg || {};
      host.innerHTML =
        '<div class="bc-class"><div class="lbl">'+TT('bc.js.behavioural_cohort')+'</div><div class="name">' + esc(d.cohort) + "</div></div>" +
        '<div class="bc-vmeta">' +
          vrow(TR('behavi.g.sessions'), num(d.sessions)) +
          vrow(TR('behavi.g.first_seen'), shortDate(d.first_seen)) +
          vrow(TR('behavi.g.last_seen'), shortDate(d.last_seen)) +
        "</div>" +
        '<div class="bc-flags">' +
          flag(d.returning, TR('behavi.g.returning'), TR('behavi.g.single_session')) +
          flag(d.returned_1d, TR('behavi.g.returned_1d'), TR('behavi.g.no_1d_return')) +
          flag(d.returned_7d, TR('behavi.g.returned_7d'), TR('behavi.g.no_7d_return')) +
        "</div>" +
        '<div class="bc-bars">' +
          bar(TR('behavi.g.intent'), a.intent, "var(--blue)") + bar(TR('behavi.g.frustration'), a.frustration, "var(--bad)") + bar(TR('behavi.g.attention'), a.attention, "var(--good)") +
        "</div>";
    });
  }
  function vrow(k, v) { return '<div class="bc-vrow"><span class="k">' + k + '</span><span class="v">' + esc(v) + "</span></div>"; }
  function flag(on, yes, no) { return '<span class="bc-flag ' + (on ? "on" : "off") + '">' + esc(on ? yes : no) + "</span>"; }
  function bar(cap, v, col) {
    v = Math.max(0, Math.min(100, +v || 0));
    return '<div class="bc-bar"><span class="c">' + cap + '</span><span class="t"><span class="fi" style="width:' + v + "%;background:" + col + '"></span></span><span class="v">' + v + "</span></div>";
  }
  function shortDate(s) { if (!s) return "—"; var d = new Date(String(s).replace(" ", "T") + "Z"); return isNaN(d) ? String(s).slice(0, 10) : d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "2-digit" }); }

  ready(function () {
    var f = q("from"), t = q("to");
    _rpInit();
    var open = q("load"), vidIn = q("vid");
    if (open && vidIn) open.addEventListener("click", function () { loadVisitor(vidIn.value.trim()); });
    if (vidIn) vidIn.addEventListener("keydown", function (e) { if (e.key === TR('behavi.g.enter')) loadVisitor(vidIn.value.trim()); });
    loadCohorts();
    var id = new URLSearchParams(location.search).get("id");
    if (id) { if (vidIn) vidIn.value = id; loadVisitor(id); }
  });
})();
